import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface InitialState {
  clientFunds: string;
  netAllocation: string;
  investmentAmount: number;
}

const initialState: InitialState = {
  clientFunds: "",
  netAllocation: "",
  investmentAmount: 0,
};

const safelyCalculateInvestmentAmount = (
  clientFunds: string,
  netAllocation: string
) => {
  return parseFloat(
    (
      (parseFloat(clientFunds || "0") * parseFloat(netAllocation || "0")) /
      100
    ).toFixed(10)
  );
};

const investmentAmountSlice = createSlice({
  name: "investmentAmount",
  initialState,
  reducers: {
    updateClientFunds: (state, action: PayloadAction<string>) => {
      state.clientFunds = action.payload;
      state.investmentAmount = safelyCalculateInvestmentAmount(
        state.clientFunds,
        state.netAllocation
      );
    },
    updateNetAllocation: (state, action: PayloadAction<string>) => {
      state.netAllocation = action.payload;
      state.investmentAmount = safelyCalculateInvestmentAmount(
        state.clientFunds,
        state.netAllocation
      );
    },
  },
});

export default investmentAmountSlice.reducer;
export const investmentAmountActions = investmentAmountSlice.actions;
